
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#FFAE80"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 4.559c-.728 0-1.327.597-1.327 1.344v1.184h2.653V5.903c0-.747-.598-1.344-1.326-1.344zm2.236 2.528V5.903c0-1.24-.997-2.254-2.236-2.254a2.245 2.245 0 00-2.236 2.254v1.184c-.752.005-1.336.628-1.336 1.371v2.521c0 .747.589 1.372 1.346 1.372h4.452c.757 0 1.345-.625 1.345-1.372V8.46c0-.744-.583-1.367-1.335-1.372zm-4.462.91a.448.448 0 00-.436.461v2.521c0 .27.206.463.436.463h4.452c.23 0 .436-.193.436-.463V8.46a.448.448 0 00-.436-.463H5.774z","fill":"#fff"}})])
          )
        }
      }
    